import GeneralForms from './generalForms';
import CompanyAddresses from './addressForm';
import CompanyUser from './authoriesForm';
import InformationForm from './informationForm';
import ReserveAccount from './reserveForm';
import ServiceForm from './serviceForm';
import Appointment from './appointmentForm';
import MovementForms from './movementForm';
import MovementImageForms from './movementImage';
import MovementProductForms from './movementProduct';

export default {
    GeneralForms, CompanyAddresses, CompanyUser, InformationForm, ReserveAccount, 
    ServiceForm, Appointment, MovementForms, MovementImageForms, MovementProductForms
}


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/index.js